import { render, staticRenderFns } from "./NotValidNoticePopup.vue?vue&type=template&id=386fd1e4&scoped=true"
import script from "./NotValidNoticePopup.vue?vue&type=script&lang=js"
export * from "./NotValidNoticePopup.vue?vue&type=script&lang=js"
import style0 from "./NotValidNoticePopup.vue?vue&type=style&index=0&id=386fd1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386fd1e4",
  null
  
)

export default component.exports